// views/Account/AuthRedirect.js
import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../utils/contextapi/AuthProvider";
import { setCookie, getCookie, deleteCookie } from '../../utils/cookies/cookies.js';

import axios from "../../utils/api/axios";
import { CLIENT_ID, CLIENT_SECRET, IAM_PATH, NONCE, OAUTH, OAUTH_AUTHORIZE, OAUTH_TOKEN, REDIRECT_URI, RESPONSE_TYPE, SCOPE, STATE } from "../../utils/Config";

function AuthRedirect() {
  const {
    saveToken,
    saveAuthenticated,
    saveTokenExpiresIn,
    saveUser,
    saveRole,
    doLogout,
    saveRefreshToken
  } = useContext(AuthContext);

  async function getPublicIp() {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Failed to get public IP:', error);
      return null;
    }
  }

  const navigate = useNavigate();

  useEffect(() => {
    // 자식이 로딩되면 부모에게 ready 전송
    window.opener?.postMessage({ type: "AUTH_READY" }, "*");

    const handler = async (event) => {

      const allowedOrigins = ["null", "https://iam.innocode.co", "https://10.10.4.20:9090", "http://10.10.4.20:10403"];
      const publicIp = await getPublicIp();

      const eventData = event.data;
      if (eventData?.type === "AUTH_CONTEXT") {

        const { userId, path, pathData } = eventData;

        const storageToken = getCookie('accessToken');
        const storageTokenExpiresIn = getCookie('tokenExpiresIn');


        // 현재 시간 (밀리초)
        const currentTime = Date.now();
        if (storageToken && storageTokenExpiresIn && Number(storageTokenExpiresIn) > currentTime) {

          // saveToken(storageToken, storageTokenExpiresIn);
          // saveTokenExpiresIn(Number(storageTokenExpiresIn));
          // saveRefreshToken(storageRefreshToken, refresh_token_expires_in);

          saveAuthenticated(true);

          axios.get(OAUTH + "/userinfo")
            .then(userRes => {
              const { data } = userRes;
              const roles = Array.isArray(data.roles) ? data.roles.filter(Boolean) : ["USER"];

              saveRole(roles); // context에 저장
              saveUser(data);

              // sessionStorage.setItem("roles", JSON.stringify(roles));
              // sessionStorage.setItem("user", JSON.stringify(data));
              saveAuthenticated(true);

              setTimeout(() => {
                if (path == 'subscriptionDetail') {
                  navigate(`/subscription/detail/${pathData.subscriptionId}?enableGobackBar=true`);
                } else if (path == 'paymentHistoryDetail') {
                  navigate(`/payment_history/detail/${pathData.paymentId}?enableGobackBar=true`);
                } else {
                  navigate("/account/manage");
                }
              }, 100);
            })
        } else {
          doLogout();

          const url = IAM_PATH + "/login";
          const data = { unifiedProfileId: userId, type: "account_iam" }

          axios.post(url, data, { withCredentials: true })
            .then(response => {
              const loginToken = response.data.data.login_token;
              const authorizeConfig = {
                response_type: RESPONSE_TYPE,
                client_id: CLIENT_ID,
                redirect_uri: REDIRECT_URI,
                scope: SCOPE,
                state: STATE,
                nonce: NONCE,
                clientIp: publicIp
              };

              const authorizeQueryString = new URLSearchParams(authorizeConfig).toString();
              const authorizeUrl = `${OAUTH_AUTHORIZE}?${authorizeQueryString}`;

              axios.get(authorizeUrl, {
                headers: { Authorization: `Bearer ${loginToken}` }, withCredentials: true
              })
                .then(response => {
                  const authorization_code = response.data.code;
                  const tokenConfig = {
                    grant_type: "authorization_code",
                    code: authorization_code,
                    client_id: CLIENT_ID,
                    client_secret: CLIENT_SECRET,
                    redirect_uri: REDIRECT_URI,
                    scope: SCOPE,
                    state: STATE,
                    code_verifier: NONCE,
                  };

                  const tokenQueryString = new URLSearchParams(tokenConfig).toString();

                  const toeknUrl = `${OAUTH_TOKEN}?${tokenQueryString}`;

                  axios.post(toeknUrl, { withCredentials: true })
                    .then(response => {
                      const { access_token, expires_in, id_token, refresh_token, exp_timestamp, refresh_token_expires_in } = response.data;

                      let finalExpiresIn;
                      if (exp_timestamp) {
                        // 서버에서 정확한 타임스탬프를 줬으므로 그대로 사용 (밀리초 단위로 가정)
                        finalExpiresIn = exp_timestamp;
                      } else {
                        // 혹시 서버에서 주지 않는 경우를 위한 fallback (기존 방식)
                        finalExpiresIn = Date.now() + (expires_in * 1000);
                      }

                      saveTokenExpiresIn(finalExpiresIn);
                      saveToken(access_token, finalExpiresIn);
                      saveRefreshToken(refresh_token, refresh_token_expires_in);

                      // 크롬이 완전히 닫혔다가 열렸을 경우, 해당 값을 토대로 재로그인 기능 구현.
                      // sessionStorage.setItem("access_token", access_token);
                      // sessionStorage.setItem("refresh_token", refresh_token);
                      // sessionStorage.setItem("tokenExpiresIn", finalExpiresIn);
                      setCookie("user_id", userId, finalExpiresIn);

                      axios.get(OAUTH + "/userinfo")
                        .then(userRes => {
                          const { data } = userRes;
                          const roles = Array.isArray(data.roles) ? data.roles.filter(Boolean) : ["USER"];

                          saveRole(roles, finalExpiresIn); // context에 저장
                          saveUser(data, finalExpiresIn);

                          // sessionStorage.setItem("roles", JSON.stringify(roles));
                          // sessionStorage.setItem("user", JSON.stringify(data));

                          setTimeout(() => {
                            if (path == 'subscriptionDetail') {
                              navigate(`/subscription/detail/${pathData.subscriptionId}?enableGobackBar=true`);
                            } else if (path == 'paymentHistoryDetail') {
                              navigate(`/payment_history/detail/${pathData.paymentId}?enableGobackBar=true`);
                            } else {
                              navigate("/account/manage");
                            }
                          }, 100);
                        })
                    })
                    .catch(error => {
                      console.error('OAUTH_TOKEN', error);
                    });
                })
                .catch(error => {
                  console.error('OAUTH_AUTHORIZE', error);
                });
            })
            .catch(error => {
              console.error(error);
            });
        }
      }
    };

    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);

  return <div></div>;
}

export default AuthRedirect;
